/**
 * Prompt Builder controller - builds prompt text from form inputs
 */

/**
 * Build prompt text from form data
 * @param {Object} formData - Form data with persona, format, context, task, dos, donts, examples
 * @returns {string} The constructed prompt text
 */
export const buildPrompt = (formData) => {
  const parts = [];

  if (formData.persona) {
    parts.push(formData.persona);
  }

  if (formData.context) {
    parts.push(`Context: ${formData.context}`);
  }

  if (formData.task) {
    parts.push(`Task: ${formData.task}`);
  }

  if (formData.dos) {
    parts.push(`Requirements: ${formData.dos}`);
  }

  if (formData.donts) {
    parts.push(`Constraints: ${formData.donts}`);
  }

  if (formData.format) {
    parts.push(`Format your response as: ${formData.format}`);
  }

  if (formData.examples) {
    parts.push(`Examples/Reference: ${formData.examples}`);
  }

  if (parts.length > 0) {
    parts.push(
      'Guidance for the AI:',
      '- If important details are missing or ambiguous, ask clarifying questions before answering.',
      '- Follow the requested structure exactly and avoid adding unrelated content.',
      '- Prefer clear, concise explanations that a busy professional can act on quickly.'
    );
  }

  return parts.join('\n\n');
};

